var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('footer',{staticClass:"footer text-center clearfix"},[_vm._v(_vm._s(_vm.year)+" © Coode Associates")])])}
var staticRenderFns = []

export { render, staticRenderFns }